var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer"},[_c('div',[_vm._v(_vm._s(_vm.t('免责声明：以上内容仅供参考，不作为投资依据')))]),_c('div',[_vm._v(_vm._s(_vm.t('投资有风险，入市需谨慎')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }